// extracted by mini-css-extract-plugin
module.exports = {"rightForm":"right-form_rightForm__Yblt4","agent":"right-form_agent__Up1qO"};